<template>
  <div>
    <div
      class="modal fade"
      id="createItemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 col-12 pl-md-5 pr-md-5">
                <div v-show="step == 0" class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase ">Create New Item</h5>
                  </div>
                  <div class="col-md-12  ">
                    <div class="form-group">
                      <div class="row mt-3 ml-2">
                        <div class="col-lg-6">
                          <input
                            v-model="item.active"
                            id="activitem"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="activitem" class="ml-4">Active</label>
                        </div>
                        <div class="col-lg-6">
                          <input
                            v-model="item.public"
                            id="publicitem"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="publicitem" class="ml-4">Public</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Name</label>
                      <input
                        v-model="item.title"
                        type="text"
                        class="form-control"
                        id="name"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Description::</label>
                      <editor
                        :id="'textareaitemgroup'"
                        v-model="item.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                </div>
                <div v-show="step == 1" class="row">
                  <div class="col-12">
                    <h5>WHICH KIND OF ITEM/S WOULD YOU LIKE TO ADD?</h5>
                    <p>
                      Select which kind of item you'll like to create(you can
                      select more then one type)
                    </p>
                    <ul class="itemtype-list">
                      <li
                        v-for="(itemtype, index) in itemtype_list"
                        :key="index"
                        class="itemtype"
                      >
                        <input
                          name="type"
                          @change="selectItemType(itemtype.id)"
                          v-model="itemtype.selected"
                          :id="'itemtype' + itemtype.id"
                          type="checkbox"
                          class="form-control"
                        />
                        <label :for="'itemtype' + itemtype.id">
                          {{ itemtype.title }}
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-show="step == 2" class="row">
                  <div
                    class="info-group"
                    v-for="(info, index) in itemtype_structure"
                    :key="index"
                  >
                    <h5>{{ info.title }}</h5>
                    <p class="m-0" v-html="info.description"></p>
                    <div class="fields">
                      <div
                        class="info-field"
                        v-for="(field, index) in info.fields"
                        :key="index"
                      >
                        <div class="form-group">
                          <label for=""
                            >{{ field.label.toUpperCase() }} KL</label
                          >
                          <input
                            v-model="field.value"
                            v-if="field.field == 'text'"
                            type="text"
                            class="form-control"
                          />
                          <input
                            @change="selectFile($event, field)"
                            v-if="field.field == 'image'"
                            :id="'image' + field.id"
                            type="file"
                            accept="image/*"
                            class="form-control"
                          />
                          <input
                            @change="selectFile($event, field)"
                            v-if="field.field == 'file'"
                            :id="'file' + field.id"
                            type="file"
                            class="form-control"
                          />
                          <select2
                            v-model="field.value"
                            v-if="field.field == 'select2'"
                            :options="[]"
                          />
                          <editor
                            :id="'textareainfofield' + field.id"
                            v-if="field.field == 'tinymce'"
                            v-model="field.value"
                            :init="{
                              height: 200,
                              menubar: false,
                              language: 'nl',
                              plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount',
                              ],
                              toolbar:
                                'undo redo | formatselect | bold italic backcolor | \
                                                                alignleft aligncenter alignright alignjustify | \
                                                                bullist numlist outdent indent | removeformat | help',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row d-flex">
              <div
                v-if="errorText.length > 0"
                class="col-10 m-auto pt-1 pb-1 alert alert-danger"
              >
                <p class="text-danger m-0 p-0">{{ errorText }}</p>
              </div>
              <div class="col-lg-12">
                <button
                  v-if="step == 2"
                  @click="createItem()"
                  class="btn-dark float-right mt-3 mr-2"
                >
                  <span v-if="saving">Saving</span>
                  <span v-else> Save</span>
                </button>
                <button
                  v-if="step < 2"
                  @click="next()"
                  class="btn-dark float-right mt-3"
                >
                  Next
                </button>
                <button
                  v-if="step > 0"
                  @click="prev()"
                  class="btn-dark float-left mt-3 mr-1"
                >
                  Prev
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      step: 0,
      errorText: "",
      saving: false,
      members: [],
      itemtype_list: [],
      itemtype: {},
      itemtype_structure: [],
      item: {
        title: "",
        description: "",
        active: false,
        public: false,
        parent_id: 0,
        itemtype_id: 0,
      },
    };
  },
  computed: {
    ...mapState({
      committees: (state) => state.committees,
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
    }),
  },
  methods: {
    selectFile(e, field) {
      var fileReader = new FileReader();
      fileReader.onload = function(result) {
        field.value = result.target.result;
      };
      fileReader.readAsDataURL(e.srcElement.files[0]);
    },
    selectItemType(id) {
      setTimeout(() => {
        var temp = this.itemtype_list.find((d) => d.selected);
        if (temp) {
          this.item.itemtype_id = temp.id;
          this.itemtype = temp;
          if (temp.structure) {
            var structure = temp.structure;
            this.itemtype_structure = structure.map((d) => {
              d.value = "";
              return d;
            });
          }
        }
        var list = this.itemtype_list.map((d) => {
          if (d.id != id) {
            d.selected = false;
          }
          return d;
        });
        this.itemtype_list = list;
      }, 100);
    },
    next() {
      if (this.step < 2 && this.validateStep()) {
        this.step += 1;
      }
      console.log(this.item);
    },
    prev() {
      if (this.step > 0) {
        this.step -= 1;
      }
    },
    validateStep() {
      this.errorText = "";
      var result = true;
      if (this.step == 0) {
        if (this.item.title.trim().length == 0) {
          result = false;
          this.errorText = "Enter Item title";
          return false;
        }
      } else if (this.step == 1) {
        if (this.item.itemtype_id == 0) {
          result = false;
          this.errorText = "Select an item type";
          return false;
        }
      }

      return result;
    },
    notify() {
      setTimeout(() => {
        this.members = this.resolveMembers();
      }, 300);
    },
    resolveMembers() {
      var users_list = this.committees
        .filter((d) => d.selected)
        .map((d) => d.users);
      var members = [];
      users_list.forEach((list) => {
        members = [...list, ...members];
      });
      return members;
    },
    createItem() {
      if (this.saving) return false;
      // var selected_committee_ids = this.committees.filter((d)=> d.selected).map((d)=>d.id);
      // var selected_members_ids = this.members.filter((d)=> d.selected).map((d)=>d.id);
      var fields_values = [];
      this.itemtype_structure.forEach((infoG) => {
        infoG.fields.forEach((field) => {
          fields_values.push({
            group_id: infoG.id,
            field_id: field.id,
            label: field.label,
            value: field.value,
            field: field.field,
          });
        });
      });

      var item = {
        title: this.item.title,
        body: this.item.description,
        active: this.item.active,
        public: this.item.public,
        itemtype_id: this.itemtype.id,
        fields_values: fields_values,
      };
      // itemgroup.selected_committees = JSON.stringify(selected_committee_ids);
      // itemgroup.selected_members = JSON.stringify(selected_members_ids);

      this.saving = true;
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/items",
          details: item,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          this.saving = false;
          console.log(error.request);
        });
    },
  },
  created() {
    this.$store.dispatch("get", "api/v1/itemtypes").then((data) => {
      console.log(data);
      this.itemtype_list = data.data.data.map((d) => {
        d.selected = false;
        return d;
      });
    });
  },
};
</script>
<style scoped>
ul {
  padding: 0px;
}
.itemtype-list {
  list-style-type: none;
}
.itemtype {
  display: flex;
}
.itemtype input[type="checkbox"] {
  width: 15px;
  height: 15px;
  display: block;
  margin-top: 5px;
  margin-right: 5px;
}
</style>
